var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useLayoutEffect, useRef, useState, } from 'react';
import { styled } from '@material-ui/core/styles';
import { InputBase } from '@material-ui/core';
var segmentConfig = {
    month: {
        placeholder: 'MM',
        maxLength: 2,
    },
    day: {
        placeholder: 'DD',
        maxLength: 2,
    },
    year: {
        placeholder: 'YYYY',
        maxLength: 4,
    },
};
var StyledSegmentInput = styled(InputBase)(function (_a) {
    var theme = _a.theme;
    return ({
        '& .MuiInputBase-input': {
            fontSize: theme.typography.body1.fontSize,
            fontFamily: theme.typography.fontFamily,
            '&::placeholder': {
                color: theme.palette.text.disabled,
                opacity: 1,
            },
        },
    });
});
var Sizer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        top: 0,
        left: 0,
        height: 0,
        overflow: 'scroll',
        visibility: 'hidden',
        whiteSpace: 'pre',
        fontSize: theme.typography.body1.fontSize,
        fontFamily: theme.typography.fontFamily,
    });
});
var SegmentInput = function (_a) {
    var value = _a.value, type = _a.type, onChange = _a.onChange, onKeyDown = _a.onKeyDown, onClick = _a.onClick, onFocus = _a.onFocus, props = __rest(_a, ["value", "type", "onChange", "onKeyDown", "onClick", "onFocus"]);
    var sizerRef = useRef(null);
    var _b = useState(0), width = _b[0], setWidth = _b[1];
    useLayoutEffect(function () {
        if (sizerRef.current) {
            setWidth(sizerRef.current.scrollWidth + 1);
        }
    }, [value]);
    var handleMouseDown = useCallback(function (e) {
        e.preventDefault();
    }, []);
    var _c = segmentConfig[type], placeholder = _c.placeholder, maxLength = _c.maxLength;
    var sizerContent = value || placeholder;
    return (React.createElement("div", { style: { position: 'relative' } },
        React.createElement(Sizer, { ref: sizerRef }, sizerContent),
        React.createElement(StyledSegmentInput, __assign({ value: value, placeholder: placeholder, onChange: onChange, onKeyDown: onKeyDown, onClick: onClick, onFocus: onFocus, onMouseDown: handleMouseDown, inputProps: {
                maxLength: maxLength,
                style: {
                    textAlign: 'center',
                    border: 'none',
                    boxShadow: 'none',
                    padding: 0,
                },
            }, style: { width: width + "px" }, "aria-label": type }, props))));
};
export default SegmentInput;
